import { render, staticRenderFns } from "./editFullFift.vue?vue&type=template&id=717f2272&scoped=true&"
import script from "./editFullFift.vue?vue&type=script&lang=js&"
export * from "./editFullFift.vue?vue&type=script&lang=js&"
import style0 from "./editFullFift.vue?vue&type=style&index=0&id=717f2272&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717f2272",
  null
  
)

export default component.exports